
import MessagesService from "@services/messages-home-service";
import { initialiseComponents } from "../../core";
import { deprecatedGetAccountData } from "../account/account-data/account-data";
import Component from "../component.abstract";
import { hw } from "../helpers/paths";

interface MessagesProps {
  url: string;
}

export default class Messages extends Component {
  private url: string;
  private service: MessagesService;
  public data: any;
  constructor(private props: MessagesProps, element: HTMLElement) {
    super(props, element);
    this.url = props.url;
  }

  mounted(): void {
    if (this.url) {
      this.call(this.url);
    }
  }
  call(url: string): void {
    this.service = new MessagesService(url);
    this.service.post({}, this.handleResponse.bind(this));
    this.service.setErrorHandler((error: any) => {
     this.hideLazySection();
      this.data = error;
    });
  }
  handleResponse(response: any): void {
    this.data = response;

    if (this.data?.items.length) {
      const idx = 0;
      const titre = document.createElement("h2");
      const svgns = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgns, "svg");
      svg.setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/hello.svg");
      titre.appendChild(svg);
      titre.innerHTML = titre.innerHTML + " Hello " + deprecatedGetAccountData().FirstName + " ! Vous avez " + this.data.count + " message" + (this.data.count > 1 ? "s" : "");
      this.element.appendChild(titre);
    
      for (let i = 0; i < this.data.items.length; i++) {
          const offer = document.createElement("div");
          const dt = '{"message" : "message", "idx" : ' + (idx + i) + '}';
          offer.setAttribute("data-message-item", dt);
          this.element.appendChild(offer);
      }
    }

    initialiseComponents();
    PubSub.publish("messages.loaded", this);
    if (this.element.className.indexOf("global-lazy-loading") >= 0) {
      // Wait for the other lazy components before displaying the results
      this.element.addEventListener("display", () => {
        this.displayResults(response);
      });
      this.element.dispatchEvent(new CustomEvent("ready"));
    } else {
      // Just display the results
      this.displayResults(response);
    }
  }
  displayResults(response: any): void {
    this.hideLazySection();

    if (response?.items.length) {
         document.querySelector("section.hide:not(.lazy)").classList.remove("hide");
         if(response.items.length === 1) {
            const previous = this.element.querySelector(".previous"),
              next = this.element.querySelector(".next");
            if (previous && next) {
              previous.classList.add("hide");
              next.classList.add("hide");
            }
         }
    } 

  }
  hideLazySection():void {
    document.querySelector("section.lazy").classList.add("hide");
  }
}
